import PlurallClient from '@plurall/client'
import { TOGGLE_PRIVACY_PREFERENCES } from 'graphql/mutations'
import { GET_PRIVACY_PREFERENCES } from 'graphql/queries'

import { getToken } from 'utils'

export const useMSClient = () => {
  const authToken = getToken()

  const client = new PlurallClient({
    accessToken: authToken,
    applicationId: process.env.REACT_APP_ID_APPLICATION,
    apiURL: `${process.env.REACT_APP_MS_API_URL}/privacy-preferences/graphql`,
    graphqlURL: `${process.env.REACT_APP_MS_API_URL}/privacy-preferences/graphql`,
    disableAutoCamelize: false,
  })

  const getPrivacyPreferences = async () => {
    const { data } = await client.graphqlClient.query({
      query: GET_PRIVACY_PREFERENCES,
      variables: {
        input: {
          type: 'MARKETING',
        },
      },
    })

    return data
  }

  const togglePrivacyPreferences = async channel => {
    await client.graphqlClient.mutate({
      mutation: TOGGLE_PRIVACY_PREFERENCES,
      variables: {
        input: {
          type: 'MARKETING',
          channels: [{ channel }],
        },
      },
    })
  }

  return {
    getPrivacyPreferences,
    togglePrivacyPreferences,
  }
}
